import React from 'react';
import AsyncState from '../../../components/AsyncState';
import { useLanguage } from '../../../contexts/LanguageContext';
import { translations } from '../../../translations';
import { formatDateTime } from '../../../utils/format';

// One short line of context per activity, or nothing when the action name says it all.
function detailText(item, t) {
  const status = item.diff?.status;
  if (status) return `${t.statusLabel[status.from] || status.from} → ${t.statusLabel[status.to] || status.to}`;
  const details = item.details || {};
  if (details.filename) return `${details.filename}${details.category ? ` (${t.categoryLabel[details.category] || details.category})` : ''}`;
  if (details.preview) return details.preview;
  if (details.flavorName) return [details.flavorName, details.versionName].filter(Boolean).join(' ');
  return details.note || '';
}

export default function ActivityPanel({ timeline }) {
  const { language } = useLanguage();
  const t = translations[language];
  const items = [...(timeline.data?.items || [])].reverse();

  return <section className="card stack" aria-labelledby="activity-heading">
    <h2 id="activity-heading">{t.activityTitle}</h2>
    <AsyncState state={timeline} retry={timeline.retry} isEmpty={items.length === 0} empty={<p className="hint">{t.activityEmpty}</p>}>
      <ol className="timeline">
        {items.map((item) => <li key={item.id}>
          <time dateTime={item.createdAt}>{formatDateTime(item.createdAt, language)}</time>
          <span><strong>{t.actionLabel[item.action] || item.action}</strong> · {item.actor?.name || t.teamMember}{item.actor?.role ? ` (${item.actor.role})` : ''}</span>
          {detailText(item, t) && <small>{detailText(item, t)}</small>}
        </li>)}
      </ol>
    </AsyncState>
  </section>;
}
